module.exports = __webpack_public_path__ + "toBride1-we-b-b.e3cd2858.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/toBride1-we-b-b.jpg
// module id = pwtK
// module chunks = 0